import { AppValueTypes } from '@iotv/iotv-v3-types';
import { formatTimeDifference } from '../Expandable/ExpandableTable';
export const gatewayDefinition = {
    type: 'Gateway',
    definition: {
        name: {
            key: 'name',
            label: 'Name',
            type: AppValueTypes.STRING,
        },
        billingGroup: {
            key: 'billingGroup',
            label: 'Group',
            type: AppValueTypes.STRING,
        },
        isAWOL: {
            key: 'isAWOL',
            label: 'AWOL',
            type: AppValueTypes.BOOLEAN,
        },
        lastSeen: {
            key: 'lastSeen',
            label: 'Last Seen',
            type: AppValueTypes.DATE,
        },
        rssi: {
            key: 'rssi',
            label: 'RSSI',
            type: AppValueTypes.NUMBER,
            summary: {
                average: true,
            },
        },
    },
};
export const customerDefinition = {
    type: 'Customer',
    definition: {
        name: {
            key: 'name',
            label: 'Name',
            type: AppValueTypes.STRING,
        },
    },
};
export const deviceDefinition = {
    type: 'Device',
    definition: {
        name: {
            key: 'name',
            label: 'Name',
            type: AppValueTypes.STRING,
        },
        billingGroup: {
            key: 'billingGroup',
            label: 'Group',
            type: AppValueTypes.STRING,
        },
        lastGatewayEui: {
            key: 'lastGatewayEui',
            label: 'Last Gateway',
            type: AppValueTypes.STRING,
        },
        isAWOL: {
            key: 'isAWOL',
            label: 'AWOL',
            type: AppValueTypes.BOOLEAN,
        },
        lastSeen: {
            key: 'lastSeen',
            label: 'Last Seen',
            type: AppValueTypes.DATE,
        },
        lastSeenTime: {
            key: 'lastSeen',
            label: 'When',
            formatter: formatTimeDifference,
            type: AppValueTypes.DATE,
        },
    },
};
export const offlineExport = [
    'type',
    'name',
    'lastDeviceSeen',
    'secondaryGatewayReceiveCount',
    'networkKey',
    'wideawakePersist',
    'lastSendPeriod',
    'lastSeen',
    'primaryGatewayUplinkCount',
    'eui',
    'sk',
    'location',
    'id',
    'pk',
    'dsk',
    'isAWOL',
    'dpk',
    'firmwareLevel',
    'deviceType',
    'lastGatewayEui',
    'dailyFCntSkip',
    'minVoltage',
    'regionalPlan',
    'batterLevel',
    'channel',
    'state',
    'dr',
    'adr',
    'deviceTypeName',
    'billingGroup',
    'batteryLevel',
    'sf',
    'snr',
    'maxVoltage',
    'fCnt',
    'rfChain',
    'messageUplinkCount',
    'appID',
    'rssi',
    'dailyMessageHistory',
    'dailyMessageCount',
    'fCntSkipHistory',
    'fCntInc',
    'updated_at',
    'deviceId',
    'nasSourceIp',
];
export const DeviceExport = [
    'type',
    'name',
    'lastDeviceSeen',
    'secondaryGatewayReceiveCount',
    'networkKey',
    'wideawakePersist',
    'lastSendPeriod',
    'lastSeen',
    'primaryGatewayUplinkCount',
    'eui',
    'sk',
    'location',
    'id',
    'pk',
    'dsk',
    'isAWOL',
    'dpk',
    'firmwareLevel',
    'deviceType',
    'lastGatewayEui',
    'dailyFCntSkip',
    'minVoltage',
    'regionalPlan',
    'batterLevel',
    'channel',
    'state',
    'dr',
    'adr',
    'deviceTypeName',
    'billingGroup',
    'batteryLevel',
    'sf',
    'snr',
    'maxVoltage',
    'fCnt',
    'rfChain',
    'messageUplinkCount',
    'appID',
    'rssi',
    'dailyMessageHistory',
    'dailyMessageCount',
    'fCntSkipHistory',
    'fCntInc',
    'updated_at',
    'deviceId',
    'nasSourceIp',
];
